import { QueryString } from "@/app/shared/filter";

export class ItemsPageQueryString extends QueryString {
    public override get isNoValue(): boolean {
        return this._value === '';
    }
    override _fieldModelName: string = "limit";
    override _fieldName: string = "pageSize";
    constructor(value: any = "", sort: number = 0) {
        super();
        this._value = value;
    }
}